import { render } from "./Threshold.vue?vue&type=template&id=0b9f053f&scoped=true"
import script from "./Threshold.vue?vue&type=script&lang=js"
export * from "./Threshold.vue?vue&type=script&lang=js"

import "./Threshold.vue?vue&type=style&index=0&id=0b9f053f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9f053f"]])

export default __exports__